import React, { useCallback, useEffect, useRef, useState } from 'react';

import _ from 'lodash';
import { Button, Paper } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';

import API from 'utils/api';
import { useAuth, useMessageSender, useSocket, useSources } from 'hooks';
import { host } from 'components/theme';
import { ButtonContainer } from 'components';
import { call } from 'utils';
import { ChatPreview, ChatSender, EventHeader, GamePlay } from '../../shared';
import { InteractionList, TemplateList, UserSelector } from '../../shared';

import styles from './HostEvent.module.scss';

const HostEvent = ({ location, history }) => {
  const [event, setEvent] = useState({ id: _.get(location, 'state.id') });
  const { setFilter, sendMessage } = useMessageSender(event);

  const templateList = useRef(null);
  const interactionList = useRef(null);
  const eventHeader = useRef(null);
  const gamePlay = useRef(null);

  const sources = useSources();
  const auth = useAuth();

  const back = useCallback(() => history.push('/dashboard/channel/host'), [history]);

  const fetchData = useCallback(
    id =>
      API.getChannelEvent(
        id,
        {
          populate: 'channel host game',
          query: JSON.stringify({ active: true }),
        },
        sources
      ).then(({ data }) =>
        data && _.get(data.host, '_id') === auth.user._id
          ? setEvent({ id, ...data })
          : back()
      ),
    [sources, back]
  );

  useSocket(
    'webapp/control',
    { join: event.id },
    {
      refreshActiveInteractions: () => {
        call((templateList.current || {}).reload);
        call((interactionList.current || {}).reload);
      },
      updateOnline: users => call((eventHeader.current || {}).setOnlineUsers, users),
      eventUpdated: () => fetchData(event.id),
      changeEventState: msg => {
        if (!msg || !msg.event || msg.channel) {
          back();
        }
      },
      newPlay: () => call((gamePlay.current || {}).reload),
    }
  );

  useEffect(() => {
    event.id ? fetchData(event.id) : back();
  }, [event.id, fetchData, back]);

  if (!event._id) {
    return null;
  }

  return (
    <ThemeProvider theme={host}>
      <div className={styles.hostEvent}>
        <ButtonContainer position="top">
          <Button onClick={back}>back to event list</Button>
        </ButtonContainer>

        <EventHeader ref={eventHeader} event={event} onClose={back} />

        <div className={styles.body}>
          <div className={styles.left}>
            <div className={styles.grid}>
              <UserSelector event={event} onChange={setFilter} />
              <GamePlay ref={gamePlay} event={event} onMessage={sendMessage} />
            </div>

            <TemplateList ref={templateList} event={event} onMessage={sendMessage} />

            <InteractionList
              ref={interactionList}
              event={event}
              onMessage={sendMessage}
            />
          </div>

          <Paper className={styles.right}>
            <ChatPreview event={event} showSettings />
            <ChatSender event={event} onMessage={sendMessage} />
          </Paper>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default HostEvent;
